import React from 'react';


import '../styles/LeyendaAcotaciones.css';

const acotaciones = [
  { nombre: 'Agroindustria', icono: '/assets/tractor.png' },
  { nombre: 'Papel y pulpa', icono: '/assets/paper-roll.png' },
  { nombre: 'Química y petroquímica', icono: '/assets/industry.png' },
  { nombre: 'Puertos', icono: '/assets/cruise.png' }
];

const LeyendaAcotaciones = () => {
  return (
    <div className="panel">
      <h3 className="titulo">Acotaciones</h3>
      <ul className="lista">
        {acotaciones.map((a, i) => (
          <li key={i} className="item">
            <img src={a.icono} alt={a.nombre} className="icono" />
            <span>{a.nombre}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeyendaAcotaciones;